// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2boyR","label":"SetPasswdForm_label__1e0Tg"};